<template>
	<Modal ref="modal" :width="299" :gc="gc" :cc="cc" :title="config.title" @closeModal="closePopover">
		<div class="lottie" v-if="config.type == 3" :style="{'background-image': `url(${cc.popover_image})`}"></div>
		<div class="message-content">
			<div class="prize-box" v-if="config.type == 0">
				<p class="message" :style="{'color': gc.main_color}">{{config.msg}}</p>
				<div class="btn-confirm ysbt-font" v-if="gc.modal_confirm_btn_big" @click="closePopover" :style="{'background-image': `url(${gc.modal_confirm_btn_big})`, 'color': gc.text_color}">确定</div>
				<div class="btn-confirm ysbt-font" v-else @click="closePopover" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">确定</div>
			</div>
			<div class="loading-box" v-if="config.type == 7">
				<div class="svg-box">
					<svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" :stroke="cc.theme_color" class="path"></circle></svg>
				</div>
				<div class="desc" v-if="config.timeout">
					<p :style="{'color': gc.main_color}">{{config.timeout}}</p>
				</div>
				<div class="btn-confirm ysbt-font" v-if="gc.modal_confirm_btn_big" @click="closePopover" :style="{'background-image': `url(${gc.modal_confirm_btn_big})`, 'color': gc.text_color}">取消</div>
				<div class="btn-confirm ysbt-font" v-else @click="closePopover" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">取消</div>
			</div>
			<div class="prize-box" v-if="config.type == 6">
				<p class="message" :style="{'color': gc.main_color}">您还没有登录，是否前往登录？</p>
				<div class="btn-confirm ysbt-font" v-if="gc.modal_confirm_btn_big" @click="linkToLogin" :style="{'background-image': `url(${gc.modal_confirm_btn_big})`, 'color': gc.text_color}">去登录</div>
				<div class="btn-confirm ysbt-font" v-else @click="linkToLogin" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">去登录</div>
			</div>
			<div class="records" v-if="config.type == 5">
				<div class="record-item" v-for="item in config.records" :key="item.timestamp">
					<img class="box-img" v-if="item.machine_id && item.box_img" :src="item.box_img" alt="">
					<p class="text-2" :style="{'color': gc.main_color}">获得</p>
					<div class="prize-name">
						<div class="inner" :class="'color-'+item.rarity">
							<p class="tag" :style="{'color': cc.is_fudai ? gc.main_color : gc.text_color}">{{item.rarity == 1 ? '传说' : item.rarity == 2 ? '史诗' : item.rarity == 3 ? '稀有' : '普通'}}</p>
							<p class="text-4" :style="{'color': gc.main_color}">{{item.itemname}}</p>
						</div>
					</div>
					<p class="text-1" :style="{'color': hexToRgba(gc.main_color, 0.6)}">{{item.timestamp | formatTimestamp}}</p>
				</div>
				<no-data :color="gc.main_color" v-if="config.records.length == 0" desc="您暂无中奖记录"></no-data>
			</div>
			<div class="prize-box" v-if="config.type == 4">
				<p class="message" :style="{'color': gc.main_color}">您的余额不足，请前往充值</p>
				<div class="btn-confirm ysbt-font" v-if="gc.modal_confirm_btn_big" @click="linkToPay" :style="{'background-image': `url(${gc.modal_confirm_btn_big})`, 'color': gc.text_color}">去充值</div>
				<div class="btn-confirm ysbt-font" v-else @click="linkToPay" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">去充值</div>
			</div>
			<div class="prize-box" v-if="config.type == 3">
				<div class="lottery-prize-list-wrapper" ref="prize-list-scroller" @touchmove.stop>
					<div
						class="lottery-item-container"
						:class="config.prize.length > 1 ? 'small-item' : 'big-item'"
						v-for="(item, index) in config.prize"
						:key="index"
					>
						<div 
							class="lottery-item" 
							:class="['color-'+item.rarity]"
						>
							<div class="prize-name">
								<p :style="{'color': gc.main_color}">{{item.name}}</p>
							</div>
							<div class="image-box">
								<img :src="item.img" alt="">
							</div>
							<p class="tag" :style="{'color': gc.text_color}">{{ ['', '传说', '史诗', '稀有', '普通'][item.rarity] }}</p>
						</div>
					</div>
				</div>
				<div 
					class="lottery-list-mask"
					:class="{
						'hidden': !showLotteryMask
					}"
					:style="{
						'background': `linear-gradient(180deg, ${hexToRgba(cc.bg_color, 0)} 0%, ${cc.bg_color} 100%)`
					}"
				></div>
				<div class="modal-desc" :style="{'color': hexToRgba(gc.main_color, 0.6)}">{{ config.prize_desc }}</div>
				<div class="btn-again-wrapper" v-if="config.prize.length == 1">
					<div
						class="btn-again ysbt-font" 
						v-if="gc.modal_confirm_btn_big || (config.buy_cnt > 1 && gc.modal_confirm_btn_small)" 
						@click="refreshPopover" 
						:style="{'background-image': `url(${config.buy_cnt > 1 ? gc.modal_confirm_btn_small : gc.modal_confirm_btn_big})`, 'color': gc.text_color}"
					>抽一次</div>
					<div 
						class="btn-again ysbt-font" 
						v-else 
						@click="refreshPopover" 
						:style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}"
					>抽一次</div>
					<template v-if="config.buy_cnt > 1">
						<div 
							class="btn-again" 
							v-if="gc.modal_confirm_btn_small"
							@click="refreshPopover(true)" 
							:style="{'background-image': `url(${gc.modal_confirm_btn_small})`, 'color': gc.text_color}"
						>
							抽{{ (config.show_buy_cnt || config.buy_cnt) | formatNumToChinese }}次
							<icon-corner :bg_color="cc.corner_bg_color"></icon-corner>
						</div>
						<div 
							class="btn-again ysbt-font" 
							v-else 
							@click="refreshPopover(true)" 
							:style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}"
						>
							抽{{ (config.show_buy_cnt || config.buy_cnt) | formatNumToChinese }}次
							<icon-corner :bg_color="cc.corner_bg_color"></icon-corner>
						</div>
					</template>
				</div>
				<div class="btn-again-wrapper" v-else>
					<div
						class="btn-again ysbt-font" 
						v-if="gc.modal_confirm_btn_small" 
						@click="closePopover" 
						:style="{'background-image': `url(${gc.modal_confirm_btn_small})`, 'color': gc.text_color}"
					>全部收下</div>
					<div 
						class="btn-again ysbt-font" 
						v-else 
						@click="closePopover" 
						:style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}"
					>全部收下</div>
					<div 
						class="btn-again" 
						v-if="gc.modal_confirm_btn_small"
						@click="onScreenShot" 
						:style="{'background-image': `url(${gc.modal_confirm_btn_small})`, 'color': gc.text_color}"
					>分享</div>
					<div 
						class="btn-again ysbt-font" 
						v-else 
						@click="onScreenShot" 
						:style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}"
					>分享</div>
				</div>
			</div>
			<div class="prize-box" v-if="config.type == 13">
				<div class="lottery-prize-list-wrapper" ref="prize-list-scroller" @touchmove.stop>
					<div
						class="lottery-item-container"
						:class="config.prize.length > 1 ? 'small-item' : 'big-item'"
						v-for="(item, index) in config.prize"
						:key="index"
					>
						<div 
							class="lottery-item" 
							:class="['color-'+item.rarity]"
						>
							<div class="prize-name">
								<p :style="{'color': cc.is_fudai ? gc.main_color : gc.text_color}">{{item.name}}</p>
							</div>
							<div class="image-box">
								<img :src="item.img" alt="">
							</div>
							<p class="tag" :style="{'color': cc.is_fudai ? gc.main_color : gc.text_color}">{{ ['', '传说', '史诗', '稀有', '普通'][item.rarity] }}</p>
						</div>
					</div>
				</div>
				<div 
					class="lottery-list-mask"
					:class="{
						'hidden': !showLotteryMask
					}"
					:style="{
						'background': `linear-gradient(180deg, ${hexToRgba(cc.bg_color, 0)} 0%, ${cc.bg_color} 100%)`
					}"
				></div>
				<div class="modal-desc" :style="{'color': hexToRgba(gc.main_color, 0.6)}">{{ config.prize_desc }}</div>
				<div class="btn-again-wrapper">
					<div
						class="btn-again ysbt-font" 
						v-if="cc.btn_small_lottery" 
						@click="refreshPopover" 
						:style="{'background-image': `url(${cc.btn_small_lottery})`, 'color': gc.text_color}"
					>再开一个</div>
					<div 
						class="btn-again ysbt-font" 
						v-else 
						@click="refreshPopover" 
						:style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}"
					>再开一个</div>
				</div>
			</div>
			<div class="confirm-box" v-if="config.type == 2">
				<p class="desc" :style="{'color': gc.main_color}">
					<span class="text">确认花费</span>
					<span class="h-coin"><h-coin :cc="cc"></h-coin></span>
					<span class="number">{{config.hcoin * config.buy_cnt}}</span>
					<span class="text">抽取{{ (config.show_buy_cnt || config.buy_cnt) | formatNumToChinese }}次{{config.name}}吗？</span>
				</p>
				<div class="btn-confirm ysbt-font" v-if="gc.modal_confirm_btn_big" @click="confirmPopover('get')" :style="{'background-image': `url(${gc.modal_confirm_btn_big})`, 'color': gc.text_color}">确定</div>
				<div class="btn-confirm ysbt-font" v-else @click="confirmPopover('get')" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">确定</div>
			</div>
			<div class="confirm-box" v-if="config.type == 10">
				<p class="desc" :style="{'color': gc.main_color}">
					<span class="text">确认花费</span>
					<span class="h-coin"><hbalance :cc="cc"></hbalance></span>
					<span class="number">{{(config.balance * config.buy_cnt / 100).toFixed(2)}}</span>
					<span class="text">抽取{{ (config.show_buy_cnt || config.buy_cnt) | formatNumToChinese }}次{{config.name}}吗？</span>
				</p>
				<div class="btn-confirm ysbt-font" v-if="gc.modal_confirm_btn_big" @click="confirmPopover('get')" :style="{'background-image': `url(${gc.modal_confirm_btn_big})`, 'color': gc.text_color}">确定</div>
				<div class="btn-confirm ysbt-font" v-else @click="confirmPopover('get')" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">确定</div>
			</div>
			<div class="confirm-box" v-if="config.type == 11">
				<p class="desc" :style="{'color': gc.main_color}">
					<span class="text">H币余额不足,是否使用¥{{Math.ceil(Math.abs((config.hcoin * config.buy_cnt) - config.user_coin) / 10) / 100}}余额补齐并</span>
					<span class="text">抽取{{ (config.show_buy_cnt || config.buy_cnt) | formatNumToChinese }}次{{config.name}}吗？</span>
				</p>
				<div class="btn-confirm ysbt-font" v-if="gc.modal_confirm_btn_big" @click="confirmPopover('get')" :style="{'background-image': `url(${gc.modal_confirm_btn_big})`, 'color': gc.text_color}">确定</div>
				<div class="btn-confirm ysbt-font" v-else @click="confirmPopover('get')" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">确定</div>
			</div>
			<div class="probability" v-if="config.type == 1">
				<p v-for="item in config.ratio" :class="'color-'+item.rarity" :key="item.rarity">
					<span class="types">{{['传说', '史诗', '稀有', '普通'][item.rarity-1]}}奖品</span>
					<span class="ratio" :style="{'color': gc.main_color}">{{item.ratio}}</span>
				</p>
			</div>
			<div class="subscribe-box" v-if="config.type == 'subscribe'">
				<p :style="{'color': gc.main_color}">{{ config.desc1 }}</p>
				<div class="btn-group">
					<template v-if="config.is_hedan_sub">
						<div class="btn-confirm ysbt-font" v-if="gc.modal_cancel_btn" @click="closePopover" :style="{'background-image': `url(${gc.modal_cancel_btn})`, 'color': gc.text_color}">暂不打开</div>
						<div class="btn-confirm ysbt-font" v-else @click="closePopover" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">暂不打开</div>
					</template>
					<div class="btn-confirm ysbt-font" v-if="gc.modal_confirm_btn_small" @click="confirmPopover(config.is_hedan_sub ? 'subscribe' : 'to-subscribe')" :style="{'background-image': `url(${gc.modal_confirm_btn_small})`, 'color': gc.text_color}">打开通知</div>
					<div class="btn-confirm ysbt-font" v-else @click="confirmPopover(config.is_hedan_sub ? 'subscribe' : 'to-subscribe')" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">打开通知</div>
				</div>

			</div>
			<div class="fudai-box" v-if="config.type == 12">
				<div class="img">
					<img :src="config.img" alt="">
					<!-- <svg width="126" height="126" viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path class="light" fill-rule="evenodd" clip-rule="evenodd" d="M63 63L73.5 0H52.5L63 63ZM63 63L112.31 22.4067L122.81 40.5933L63 63ZM63 63L85.4067 3.19041L103.593 13.6904L63 63ZM63 63L112.31 103.593L122.81 85.4067L63 63ZM63 63L126 52.5V73.5L63 63ZM63 63L85.4068 122.81L103.593 112.31L63 63ZM63 63L3.19041 85.4067L13.6904 103.593L63 63ZM63 63L73.5 126H52.5L63 63ZM63 63L40.5932 122.81L22.4067 112.31L63 63ZM63 63L0 52.5V73.5L63 63ZM3.19041 40.5933L13.6904 22.4067L63 63L3.19041 40.5933ZM40.5933 3.19041L22.4068 13.6904L63 63L40.5933 3.19041Z" fill="paint_radial"/>
						<defs>
							<radialGradient id="paint_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(60.7695 63) rotate(180) scale(60.7695)">
								<stop stop-color="#CCCCCC" stop-opacity="0.12"/>
								<stop offset="1" stop-color="#CCCCCC" stop-opacity="0"/>
							</radialGradient>
						</defs>
					</svg> -->
					<svg class="light-svg" width="375" height="395" viewBox="0 0 375 395" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path class="light" fill-rule="evenodd" clip-rule="evenodd" d="M208.584 0L188.442 190.732L244.476 7.13254L283.291 23.6088L187.947 195.411L187.891 195.948L187.943 196.047L188.719 195.633L312.245 42.9379L342.062 72.755L192.952 193.38L362.398 103.178L378.194 142.275L189.293 196.34L188.873 196.681L188.841 196.786L189.682 197.043L385 176.416V218.584L194.267 198.442L377.867 254.476L361.391 293.291L189.588 197.948L188.918 197.878L189.366 198.719L342.062 322.245L312.245 352.062L191.618 202.948L281.822 372.398L242.725 388.194L188.659 199.292L188.321 198.873L188.213 198.841L187.957 199.682L208.584 395H166.416L186.557 204.267L130.524 387.867L91.7088 371.391L187.051 199.588L187.108 199.05L186.88 198.623L62.755 352.062L32.9379 322.245L186.126 198.32L186.158 198.213L185.368 197.972L13.6088 293.291L-2.86746 254.476L180.731 198.442L-10 218.584L-10 176.416L180.736 196.559L-2.86746 140.524L13.6088 101.709L185.368 197.027L185.938 196.853L185.633 196.28L32.9379 72.755L62.755 42.9379L183.38 192.048L93.1777 22.6021L132.275 6.80578L186.34 195.707L186.679 196.126L186.786 196.158L187.042 195.318L166.416 0H208.584Z" fill="url(#paint0_radial_204_9115)"/>
						<defs>
							<radialGradient id="paint0_radial_204_9115" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(187.5 197.5) rotate(90) scale(197.5)">
							<stop stop-color="#FFEBC7" stop-opacity="0.3"/>
							<stop offset="1" stop-color="#FFEBC7" stop-opacity="0"/>
							</radialGradient>
						</defs>
					</svg>
				</div>
				<p class="message" :style="{'color': gc.main_color}">{{ config.sub_title }}</p>
				<div class="btn-confirm ysbt-font" v-if="cc.btn_small_image" @click="confirmPopover('show-fudai-result')" :style="{'background-image': `url(${cc.btn_small_image})`, 'color': gc.text_color}">打开福袋</div>
				<div class="btn-confirm ysbt-font" v-else @click="confirmPopover('show-fudai-result')" :style="{'background-color': cc.theme_color, 'border-radius': '6px', 'color': gc.text_color}">打开福袋</div>
			</div>
		</div>
		<div class="message-footer" v-if="config.desc">
			<p :style="{'color': hexToRgba(gc.main_color, 0.6)}">{{config.desc}}</p>
		</div>
	</Modal>
</template>

<script type='text/ecmascript-6'>
import HCoin from './hcoin'
import Hbalance from './hbalance.vue'
import IconCorner from './icon-corner.vue'
// import { HbEmpty } from '@heybox-components/heybox-ui'
import noData from '_com/base/no-data'
import { hexToRgba } from '_lib/utils'
import Modal from '../../Modal.vue'

export default {
  props: {
    showPopover: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => {}
    },
    cc: {
      type: Object,
      default: () => {}
    },
    gc: {
      type: Object,
      default: () => {}
    },
		gd: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      show: false,
			hasScrollToBottom: false
    }
  },
	computed: {
		showLotteryMask () {
			return this.config.prize.length > 4 && !this.hasScrollToBottom
		}
	},
  mounted () {
    if (this.config.animate) {
      this.show = true
    }
  },
	watch: {
		showPopover (n, o) {
			console.log(n, o)
			if (this.config.type == 3) {
				if (this.config.prize.length > 4) {
					this.$nextTick(() => {
						if (n) {
							this.$refs['prize-list-scroller'].addEventListener('scroll', this.scrollEventHandler)
						} else {
							this.$refs['prize-list-scroller'].removeEventListener('scroll', this.scrollEventHandler)
						}
					})
				}
				if (this.config.prize.length > 2) {
					this.setScreenShot()
				}
			}
			
			if (n) {
				this.$refs.modal.showModal()
				this._top = document.documentElement.scrollTop
				document.body.classList.add('body-fixed')
				document.body.style.top = -this._top + 'px'
			} else {
				this.$refs.modal.hideModal()
				document.body.classList.remove('body-fixed')
				document.documentElement.scrollTop = this._top;
			}
		}
	},
  methods: {
		onScreenShot () {
			this.$emit('close')
			this.$root.onScreenShot()
		},
		setScreenShot () {
			this.$root.setScreenShot({
				component_name: 'shot-hedan',
				component_config: {
					screen_shot_bg: this.cc.screenshot_bg_image,
					user_info: this.gd.user_info,
					prize_list: this.config.prize,
					text_color: this.cc.screenshot_text_color,
					gc_text_color: this.gc.text_color,
					share_desc: this.gc.share_desc,
					share_title: this.gc.share_title
				}
			})
		},
		scrollEventHandler (e) {
			let itemHeight = 76
			let itemMarginTop = 11
			let target = e.target
			let scrollTop = target.scrollTop
			let scrollerHeight = target.clientHeight
			let len = Math.ceil(this.config.prize.length / 2)
			let scrollInnerHeight = len * itemHeight + (len-1) * itemMarginTop
			if (scrollTop + scrollerHeight + 10 >= scrollInnerHeight) {
				this.hasScrollToBottom = true
			} else {
				this.hasScrollToBottom = false
			}
		},
		hexToRgba: hexToRgba,
    refreshPopover (muti) {
			if (typeof muti === 'boolean' && muti) {
				this.$emit('confirm', 're-get-muti')
			} else {
				this.$emit('confirm', 're-get')
			}
    },
    confirmPopover (type) {
      this.$emit('confirm', type)
    },
    linkToPay () {
      this.$emit('pay')
    },
    closePopover () {
      if (this.config && this.config.type == 3) {
        this.$parent.reload()
      }
			if (this.showPopover) {
				this.$emit('close')
			}
    },
    linkToLogin () {
      this.closePopover()
      this.$emit('login')
    }
  },
  filters: {
		formatNumToChinese (number) {
      number = String(number)
      if ( number.match(/\D/) || number.length >= 14 ) return;
      let zhArray = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
      let baseArray = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万'];
      let string = number.split('').reverse().map((item, index) => {
          item = Number(item) == 0 ? zhArray[Number(item)] : zhArray[Number(item)] + baseArray[index];
          return item;
      }).reverse().join('');
      string = string.replace(/^一十/, '十');
      string = string.replace(/零+/, '零');
			string = string.replace(/零$/, '');
      return string;
    },
    formatTimestamp (timestamp) {
      var now = Math.ceil((new Date().getTime()) / 1000)
      var delta = Math.ceil((now - timestamp))

      if (delta < 60) {
        return `${delta}秒前`
      } else if (delta < 3600) {
        return `${Math.floor(delta/60)}分钟前`
      } else if (delta < 3600 * 24) {
        return `${Math.floor(delta/3600)}小时前`
      } else {
        return `${Math.floor(delta / (3600*24))}天前`
      }
    }
  },
  components: {
    HCoin,
    Hbalance,
		noData,
		IconCorner,
		Modal
  }
}
</script>

<style lang='less' scoped>
@import "../assets/css/lottery.less";

// Color variables (appears count calculates by raw css)
@color0: #ffffff; // Appears 14 times
@color1: #fe7f00; // Appears 6 times
@color2: #7a60ff; // Appears 6 times
@color3: #00b1fb; // Appears 6 times
@color4: #46cc76; // Appears 6 times
@color5: #8c9196; // Appears 4 times
@color6: #585858; // Appears 4 times
@color7: #2a282b; // Appears 3 times
@color8: #c8cdd2; // Appears 2 times

// Width variables (appears count calculates by raw css)
@width6: 100%; // Appears 25 times
@width8: 60px; // Appears 2 times
@width13: 18px; // Appears 2 times
@width14: 8px; // Appears 2 times

// Height variables (appears count calculates by raw css)
@height3: 100%; // Appears 3 times
@height16: 17px; // Appears 4 times
@height17: 52px; // Appears 6 times
@height18: 19px; // Appears 2 times
@height20: 18px; // Appears 5 times
@height21: 28px; // Appears 4 times
@height24: 1px; // Appears 3 times
@height25: 8px; // Appears 2 times
@height26: 2px; // Appears 2 times

.lottie {
	background-repeat: no-repeat;
	background-size: 100% 100%;
	height: 79px;
	left: 50%;
	position: absolute;
	top: -58px;
	transform: translateX(-50%);
	width: 325px;
	z-index: 2;
}
.message-content {
	width: @width6;
	.records {
		box-sizing: border-box;
		margin: 25px 0 30px;
		max-height: 188px;
		min-height: 148px;
		overflow-y: scroll;
		padding: 0 20px;
		width: @width6;
		.no-records {
			color: @color0;
			font-size: 12px;
			height: 26px;
			line-height: 26px;
			text-align: center;
		}
		.record-item {
			align-items: center;
			display: flex;
			height: 24px;
			justify-content: space-between;
			margin-top: 15px;
			&:first-of-type {
				margin-top: 0;
			}
			.box-img {
				width: 24px;
				height: 24px;
				object-fit: cover;
				margin-right: 2px;
			}
			.prize-name {
				display: flex;
				flex: 1;
				height: 24px;
				overflow: hidden;
				width: 0;
				.inner {
					align-items: center;
					border-radius: 2px;
					box-sizing: border-box;
					display: flex;
					height: 24px;
					max-width: @width6;
					padding-right: 6px;
				}
				.inner.color-1 {
					background-color: rgba(254,127,0,0.1);
					border: 1px solid @color1;
					.tag {
						background-color: @color1;
					}
				}
				.inner.color-2 {
					background-color: rgba(122,96,255,0.1);
					border: 1px solid @color2;
					.tag {
						background-color: @color2;
					}
				}
				.inner.color-3 {
					background-color: rgba(0,177,251,0.1);
					border: 1px solid @color3;
					.tag {
						background-color: @color3;
					}
				}
				.inner.color-4 {
					background-color: rgba(70,204,118,0.1);
					border: 1px solid @color4;
					.tag {
						background-color: @color4;
					}
				}
				.tag {
					align-items: center;
					color: @color0;
					display: flex;
					font-size: 12px;
					height: 100%;
					justify-content: center;
					margin-right: 4px;
					width: 43px;
				}
				.text-4 {
					color: @color8;
					flex: 1;
					font-size: 12px;
					height: 12px;
					height: @height3;
					line-height: 22px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
			p {
				display: inline-block;
			}
			p.text-1 {
				color: @color5;
				font-size: 12px;
				height: @height18;
				line-height: @height18;
				text-align: right;
				white-space: nowrap;
				width: @width8;
			}
			p.text-2 {
				color: @color5;
				font-size: 12px;
				height: @height18;
				line-height: @height18;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				white-space: nowrap;
				margin-right: 11px;
			}
		}
	}
	.loading-box {
		padding: 41px 0 19px;
		width: @width6;
		.btn-confirm {
			align-items: center;
			background-size: 100% 100%;
			box-sizing: border-box;
			color: @color0;
			display: flex;
			font-size: 15px;
			height: 36px;
			justify-content: center;
			line-height: 36px;
			margin: 16px 20px 0;
			text-align: center;
			// text-shadow: 0 2px 2px rgba(69,8,26,0.6);
		}
		.desc {
			height: @height20;
			margin-top: 30px;
			width: @width6;
			p {
				color: @color0;
				font-size: 13px;
				height: @height20;
				line-height: @height20;
				text-align: center;
			}
		}
		.svg-box {
			height: @height17;
			position: relative;
			width: @width6;
			.circular {
				animation: loading-rotate 2s linear infinite;
				height: @height17;
				left: 103px;
				position: absolute;
				top: 0;
				width: 52px;
				.path {
					animation: loading-dash 1.5s ease-in-out infinite;
					stroke-dasharray: 90, 150;
					stroke-dashoffset: 0;
					stroke-linecap: round;
					stroke-width: 1.5;
				}
			}
		}
	}
	.prize-box {
		align-items: center;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		padding: 25px 0 28px;
		width: @width6;
		position: relative;
		.message {
			color: @color0;
			font-size: 12px;
			height: @height16;
			line-height: @height16;
			margin-top: 10px;
		}
		.btn-confirm {
			align-items: center;
			background-size: 100% 100%;
			box-sizing: border-box;
			color: @color0;
			display: flex;
			font-size: 15px;
			height: 36px;
			justify-content: center;
			line-height: 36px;
			margin-top: 16px;
			text-align: center;
			// text-shadow: 0 2px 2px rgba(69,8,26,0.6);
			width: @width6;
		}
		.modal-desc {
			font-weight: 400;
			font-size: 11px;
			line-height: 15px;
			text-align: center;
			color: #64696E;
			margin-top: 14px;
			width: calc(100% + 24px);
		}
		.btn-again-wrapper {
			margin-top: 16px;
			position: relative;
			width: @width6;
			display: flex;
			.btn-again {
				align-items: center;
				background-size: 100% 100%;
				box-sizing: border-box;
				color: @color0;
				display: flex;
				font-size: 15px;
				height: 36px;
				justify-content: center;
				line-height: 36px;
				text-align: center;
				// text-shadow: 0 2px 2px rgba(69,8,26,0.6);
				width: 0;
				flex: 1;
				position: relative;
				& + .btn-again {
					margin-left: 10px;
				}
				svg {
					position: absolute;
					top: 0;
					right: 18px;
				}
			}
		}
		.lottery-list-mask {
			width: 239px;
			height: 53px;
			background: linear-gradient(180deg, rgba(29, 33, 43, 0) 0%, #1D212B 100%);
			position: absolute;
			top: 170px;
			left: 50%;
			transform: translateX(-50%);
			transition: all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
			pointer-events: none;
			&.hidden {
				opacity: 0;
			}
		}
		.lottery-prize-list-wrapper {
			width: 239px;
			max-height: 198px;
			margin: 0 auto;
			display: flex;
			flex-wrap: wrap;
			overflow: auto;
			.lottery-item-container {
				width: 155px;
				height: 103px;
				overflow: hidden;
				&.big-item {
					margin: 0 auto;
				}
				&.small-item {
					width: 114px;
					height: 76px;
					margin: 11px 11px 0 0;
					&:nth-child(2n) {
						margin: 11px 0 0 0;
					}
					&:nth-child(1) {
						margin: 0 11px 0 0;
					}
					&:nth-child(2) {
						margin: 0;
					}
					.lottery-item {
						transform: scale(0.735483871);
						transform-origin: 0 0;
					}
				}
			}
		}
	}
	.confirm-box {
		box-sizing: border-box;
		padding: 24px 22px 26px;
		width: @width6;
		.btn-confirm {
			align-items: center;
			background-size: 100% 100%;
			box-sizing: border-box;
			color: @color0;
			display: flex;
			font-weight: 500;
			font-size: 15px;
			height: 36px;
			justify-content: center;
			line-height: 36px;
			margin-top: 16px;
			text-align: center;
			// text-shadow: 0 2px 2px rgba(69,8,26,0.6);
			width: @width6;
		}
		.desc {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			line-height: @height16;
			min-height: @height16;
			width: @width6;
			span {
				display: inline-block;
			}
			.text {
				font-size: 12px;
				height: @height16;
				line-height: @height16;
			}
			.h-coin {
				height: 14px;
				margin-left: 8px;
				margin-right: 4px;
				margin-top: 1px;
				width: 14px;
			}
			.number {
				font-size: 14px;
				font-weight: bold;
				height: @height16;
				line-height: @height16;
				margin-right: 8px;
			}
		}
	}
	.subscribe-box {
		padding: 24px 22px 26px;
		width: @width6;
		p {
			font-size: 12px;
			line-height: 16px;
			text-align: center;
		}
		.btn-group {
			display: flex;
			.btn-confirm {
				align-items: center;
				background-size: 100% 100%;
				box-sizing: border-box;
				color: @color0;
				display: flex;
				font-weight: 500;
				font-size: 15px;
				height: 36px;
				justify-content: center;
				line-height: 36px;
				margin-top: 16px;
				text-align: center;
				// text-shadow: 0 2px 2px rgba(69,8,26,0.6);
				flex: 1;
				width: 0;
				&:nth-child(2) {
					margin-left: 10px;
				}
			}
		}
		
	}
	.probability {
		box-sizing: border-box;
		margin: 0 auto;
		padding: 25px 0 30px;
		width: 180px;
		p {
			align-items: center;
			border-radius: 2px;
			box-sizing: border-box;
			display: flex;
			height: 24px;
			justify-content: space-between;
			margin-top: 15px;
			padding-right: 6px;
			width: @width6;
			&:first-of-type {
				margin-top: 0;
			}
			span {
				display: inline-block;
			}
			.ratio {
				color: @color0;
				font-size: 14px;
				font-weight: 600;
				height: 20px;
				line-height: 20px;
				text-align: center;
			}
			.types {
				align-items: center;
				color: @color0;
				display: flex;
				height: 100%;
				justify-content: center;
				width: 67px;
				font-size: 12px;
				font-weight: 400;
			}
			.line {
				background-image: linear-gradient(to right, @color6 0%, @color6 50%, transparent 50%);
				background-repeat: repeat-x;
				background-size: 8px 1px;
				height: @height24;
				margin-right: 12px;
				position: relative;
				position: relative;
				width: 101px;
				&:before {
					background-color: @color7;
					border-radius: 50%;
					border: 1px solid @color6;
					box-sizing: border-box;
					content: '';
					height: @height25;
					left: 0;
					position: absolute;
					top: 0px;
					transform: translateY(-50%);
					width: @width14;
				}
				&:after {
					background-color: @color7;
					border-radius: 50%;
					border: 1px solid @color6;
					box-sizing: border-box;
					content: '';
					height: @height25;
					position: absolute;
					right: 0;
					top: 0px;
					transform: translateY(-50%);
					width: @width14;
				}
			}
		}
		p.color-1 {
			background-color: rgba(254,127,0,0.1);
			border: 1px solid @color1;
			.types {
				background-color: @color1;
			}
		}
		p.color-2 {
			background-color: rgba(122,96,255,0.1);
			border: 1px solid @color2;
			.types {
				background-color: @color2;
			}
		}
		p.color-3 {
			background-color: rgba(0,177,251,0.1);
			border: 1px solid @color3;
			.types {
				background-color: @color3;
			}
		}
		p.color-4 {
			background-color: rgba(70,204,118,0.1);
			border: 1px solid @color4;
			.types {
				background-color: @color4;
			}
		}
	}

	.fudai-box {
		height: 167px;
		padding: 73px 22px 0;
		.img {
			width: 135px;
			height: 135px;
			position: absolute;
			top: -52px;
			left: 50%;
			transform: translateX(-50%);
			img {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 120px;
				height: 120px;
				object-fit: cover;
				z-index: 1;
			}
			.light-svg {
				position: absolute;
				top: 0;
				left: 0;
				width: 135px;
				height: 135px;
				pointer-events: none;
				user-select: none;
			}
			.light {
				animation: light 6s linear infinite;
				transform-origin: center;
			}
			@keyframes light { 
				to { 
					transform: rotate(1turn);
				}
			}

		}
		.message {
			font-weight: 400;
			font-size: 16px;
			line-height: 22px;
			text-align: center;
		}

		.btn-confirm {
			align-items: center;
			background-size: 100% 100%;
			box-sizing: border-box;
			color: @color0;
			display: flex;
			font-weight: 500;
			font-size: 15px;
			height: 36px;
			justify-content: center;
			line-height: 36px;
			margin-top: 16px;
			text-align: center;
			// text-shadow: 0 2px 2px rgba(69,8,26,0.6);
			width: @width6;
		}

	}
}
.message-footer {
	overflow: hidden;
	position: relative;
	width: @width6;
	padding: 0 10px;
	p {
		color: #64696e;
		font-size: 11px;
		line-height: 15px;
		text-align: center;
		width: @width6;
	}
}
.message-title {
	overflow: hidden;
	position: relative;
	width: @width6;
	padding-top: 33px;
	.btn-close {
		position: absolute;
		right: 15px;
		top: 17px;
	}
	p {
		color: @color8;
		font-size: 16px;
		line-height: 22px;
		font-weight: 500;
		text-align: center;
		width: @width6;
	}
}
.message-title.active {
	.btn-close {
		top: 32px;
	}
}

@keyframes loading-rotate {
	to {
		transform: rotate(1turn);
	}
}
@keyframes loading-dash {
	0% {
		stroke-dasharray: 1,200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 90,150;
		stroke-dashoffset: -40px;
	}
	to {
		stroke-dasharray: 90,150;
		stroke-dashoffset: -120px;
	}
}
</style>